/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import Icon from "../../../assets/imgs/logo.webp";
import { NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Link } from "react-scroll";
//import $ from "jquery";
import "./css/navbar.css";
import Modal from "react-bootstrap/Modal";
import Fcontact from "../../Shared/Fcontact";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga";

const Navbar = () => {
  const [activeTab, setActiveTab] = useState("home");
  const [show, setShow] = useState(false);
  const [showSolutions, setShowSolutions] = useState(false);
  const [showInsights, setShowInsights] = useState(false);
  const [policy, setPolicy] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const handleClose = () => {
    setPolicy(false);
    setShow(false);
  };
  const handleShow = () => {
    setPolicy(true);
    setShow(true);
  };

  const hanldeHomePage = (eleme) => {
    ReactGA.event({
      category: "Home page navigation",
      action: eleme,
    });

    if (location?.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const violation = document.getElementById(eleme);
        window.scrollTo({
          top: violation.offsetTop,
          behavior: "smooth",
        });
      }, 50);
    }
  };

  //console.log("{}{}{}{", ReactGA)

  // const dropdownRedirect = (e) => {
  //   if (e.target.className.includes("dropdown-toggle")) {
  //     setActiveTab("insights");
  //     navigate("insights");
  //   }
  // }

  useEffect(() => {
    const violation = document.getElementById("top-menu");
    console.log(violation, "violation");
    window.scrollTo({
      top: violation.offsetTop,
      // behavior: "smooth",
    });
  }, [activeTab]);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  const handleMenuItemClick = () => {
    // Collapse the menu when a menu item is clicked
    setIsNavbarOpen(false);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top" id="top-menu">
        <div className="container-fluid">
          <NavLink
            to="/"
            onClick={() => setActiveTab("home")}
            className={(navData) =>
              navData.isActive
                ? "navbar-brand offset-lg-1 active"
                : "navbar-brand offset-lg-1"
            }
            spy={true}
            smooth={true}
            offset={-200}
            duration={500}
          >
            <img src={Icon} alt="Right Cause" width="175" height="121" />
          </NavLink>
          {/* <a className="navbar-brand offset-lg-1" href="#"><img width="175" height="121" src="img/logo.webp"
                        alt="Right Cause"></a> */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={isNavbarOpen ? "true" : "false"}
            aria-label="Toggle navigation"
            onClick={toggleNavbar}
          ></button>
          <div
            className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <div className="navbar-wrapper d-flex">
              <ul className="navbar-nav ml-auto align-items-center">
                <li className="nav-item">
                  <NavLink
                    to="/"
                    onClick={() => {
                      setActiveTab("home");
                      handleMenuItemClick();
                    }}
                    className={(navData) =>
                      navData.isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Home
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavDropdown
                    title="Solutions"
                    id="nav-dropdown"
                    className={activeTab.includes("solutions") ? "active" : ""}
                    show={showSolutions}
                    onMouseEnter={() => setShowSolutions(true)}
                    onMouseLeave={() => setShowSolutions(false)}
                  >
                    <NavDropdown.Item>
                      <NavLink
                        to="solutions/grants-management-solution"
                        onClick={() => {
                          setActiveTab("solutions/grants-management-solution");
                          handleMenuItemClick();
                        }}
                        className={
                          activeTab === "solutions/grants-management-solution"
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        Grants Management Solution
                      </NavLink>
                    </NavDropdown.Item>

                    <NavDropdown.Item>
                      <NavLink
                        to="solutions/donation-management-system"
                        onClick={() => {
                          setActiveTab("solutions/donation-management-system");
                          handleMenuItemClick();
                        }}
                        className={
                          activeTab === "solutions/donation-management-system"
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        Donation Management System
                      </NavLink>
                    </NavDropdown.Item>
                  </NavDropdown>
                </li>
                {/* <li className="nav-item dropdown">
                  <NavLink to="/" onClick={() => setActiveTab('packages')} className={(navData) => (navData.isActive ? 'nav-link active' : 'nav-link')}>
                    Packages
                  </NavLink>
                </li> */}

                {/* New Link */}
                {/* <li className="nav-item">
                  <NavLink onClick={() => {handleShow(); handleMenuItemClick()}} className={(navData) => (navData.isActive ? 'nav-link' : 'nav-link')}>
                    Packages
                  </NavLink>
                </li> */}

                <li className="nav-item">
                  <NavLink
                    to="/insights"
                    onClick={() => {
                      setActiveTab("insights");
                      handleMenuItemClick();
                    }}
                    className={(navData) =>
                      navData.isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Insights
                  </NavLink>
                </li>

                {/* <li className="nav-item">
                  <NavDropdown 
                    title="Insights" 
                    id="nav-dropdown" 
                    className={activeTab.includes('insights') ? 'active' : ''}
                    show={showInsights}
                    onMouseEnter={() => setShowInsights(true)}
                    onMouseLeave={() => setShowInsights(false)}
                    //as={NavLink}
                    //to="insights"
                    onClick={(e) => dropdownRedirect(e)}
                  >
                    <NavDropdown.Item>
                      <NavLink to="insights/blogs" onClick={() => setActiveTab("insights/blogs")} className={ activeTab === "insights/blogs" ? 'nav-link active' : 'nav-link'}>
                        Blogs
                      </NavLink>
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <NavLink to="insights/webinar" onClick={() => setActiveTab("insights/webinar")} className={ activeTab === "insights/webinar" ? 'nav-link active' : 'nav-link'}>
                        Webinar/Events
                      </NavLink>
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item>
                      <NavLink to="insights/eBook" onClick={() => setActiveTab("insights/eBook")} className={ activeTab == "insights/eBook" ? 'nav-link active' : 'nav-link'}>
                      eBook
                      </NavLink>
                    </NavDropdown.Item> */}
                {/* <NavDropdown.Item>
                      <NavLink to="insights/video" onClick={() => setActiveTab("insights/video")} className={ activeTab === "insights/video" ? 'nav-link active' : 'nav-link'}>
                        Videos
                      </NavLink>
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <NavLink to="insights/case-study" onClick={() => setActiveTab("insights/case-study")} className={ activeTab === "insights/case-study" ? 'nav-link active' : 'nav-link'}>
                        Case Studies
                      </NavLink>
                    </NavDropdown.Item>
                  </NavDropdown>
                </li> */}

                {/* <li className="nav-item">
                    <NavLink to="/pricing-plan" onClick={() => {setActiveTab('pricingPlan'); handleMenuItemClick()}} className={(navData) => (navData.isActive ? 'nav-link active' : 'nav-link')}>
                    Pricing
                    </NavLink>
                </li> */}
                <li className="nav-item">
                  <NavLink
                    to="/integrations"
                    onClick={() => {
                      setActiveTab("Integrations");
                      handleMenuItemClick();
                    }}
                    className={(navData) =>
                      navData.isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Integrations
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    to="/contact-us"
                    onClick={() => {
                      setActiveTab("contactUs");
                      handleMenuItemClick();
                    }}
                    className={(navData) =>
                      navData.isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="rightNavbar">
            <a
              onClick={handleShow}
              className="btn greenBtn getstartedBtn"
              tabIndex="0"
            >
              Request a Demo
            </a>
            {/* <a href="/pricing-plan" className="btn greenBtn strokeBtn" tabIndex="0">
              Pricing
            </a> */}
          </div>
        </div>
      </nav>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="modal_getStartedForm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Fcontact policy={policy} onSubmit={handleClose} />
      </Modal>
    </>
  );
};

export default Navbar;
